import { h, Component, Fragment } from "preact";
import { I18n } from "components/elements";
import style from "./index.less";
import {
	TimeSlots,
	CollectInformation,
	Confirmation,
	Receipt,
	Payment,
} from "components/templates";
import {
	Login,
	Filters,
	PasswordReset,
	ResetPasswordPrompt,
	ProfileSelect,
} from "components/partials";
import { Steps, LoginOrSignup } from "components/groups";
import { Page, Footer } from "components/elements";
import { Provider, connect } from "react-redux";
import store from "reducers";
import * as actions from "actions";
import { SessionActions } from "actions";
import nilLogo from "../../assets/icons/nextInLine_logo.png";

const LocaleActions = actions.LocaleActions;
window.minnowActions = actions;
@connect((state) => ({
	...state,
	access: ((state.session || {}).organizations || []).find(
		(_) => _.id == state.organization.id
	),
}))

class Widget extends Component {
	constructor() {
		super();
		this.state = {
			size: "sm",
		};
		const _onresize = document.onresize;
		window.addEventListener("resize", (e) => {
			this.handleWidth();
		});
		this.handleLogOut = this.handleLogOut.bind(this);
	}

	componentDidMount() {
		this.handleWidth();
	}

	handleWidth() {
		let size;
		if ((this.mainElement || {}).clientWidth < 768) {
			size = "sm";
		} else if ((this.mainElement || {}).clientWidth < 992) {
			size = "md";
		} else {
			size = "lg";
		}

		this.setState({
			size,
		});
	}

	handleChange(event) {
		const newLocale = event.target.value;
		LocaleActions.setLocale(newLocale);
	}

	hideStepsOnThisPage() {
		const pagesToHideSteps = [
			"loginOrSignup",
			"login",
			"filters",
			"passwordReset",
			"resetPasswordPrompt",
		];
		return (
			!this.props.config.hideSteps &&
			!pagesToHideSteps.includes(this.props.page)
		);
	}

	handleLogOut() {
		SessionActions.logout();
	}

	render() {
		const classes = [style.widgetContainer, this.state.size];
		const resetPassword =
			this.props.session && this.props.session.resetPassword;
		const accountID = this.props.session && this.props.session.accountID;
		const account = this.props.session && this.props.session.account;

		const contentTitleContainer =
			this.props.page === "loginOrSignup"
				? {
						title: I18n.t("loginOrSignupTitle"),
						subTitle: I18n.t("loginOrSignupSubTitle"),
				  }
				: this.props.page === "login"
				? {
						title: I18n.t("loginTitle"),
						subTitle: I18n.t("loginSubTitle"),
				  }
				: this.props.page === "collectInformation" &&
				  this.props.session.authenticationMode === "signup"
				? {
						title: I18n.t("contactInformationTitle"),
						subTitle: I18n.t("contactInformationSubTitle"),
				  }
				: this.props.page === "timeSlots"
				? {
						title: I18n.t("makeYourAppointment"),
						subTitle: "",
				  }
				: this.props.page === "confirmation"
				? {
						title: I18n.t("reviewYourInformation"),
						subTitle: "",
				  }
				: this.props.page === "passwordReset" ||
				  (
					this.props.page === "resetPasswordPrompt" && 
					this.props.session.authenticationMode == "reset"
				  )
				? {
						title: I18n.t("forgotYourPassword"),
						subTitle: I18n.t("forgotYourPasswordDescription"),
				  }
				: this.props.page === "resetPasswordPrompt" &&
				  this.props.session.authenticationMode == "claim"
				? {
						title: I18n.t("claimYourAccount"),
						subTitle: I18n.t("claimYourAccounDescription"),
				  }
				: undefined;

		const addLoadingClass = Object.values(this.props.loading).reduce(
			(acc, curr) => acc || curr,
			false
		);

		return (
			<div
				class={`${classes.join(" ")} ${
					addLoadingClass ? style.loadingPage : ""
				}`}
				ref={(_) => (this.mainElement = _)}
			>
				<link
					href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap"
					rel="stylesheet"
				/>
				<div class={style.containerActions}>
					<div className={style.languageSelect}>
						<select value={this.state.locale} onChange={this.handleChange}>
							<option value="en">English</option>
							<option value="esp">Español</option>
							<option value="fr">Français</option>
						</select>
					</div>
				</div>

				<div class={style.containerHeader}>
					{accountID && (
						<div className={style.sessionContainer}>
							<div class={style.loggedInTitle}>
								<I18n>welcome</I18n>, {account.title || ""}{" "}
								{account.firstName || ""} {account.lastName || ""}
							</div>
							{!resetPassword && (
								<div class={style.logOutPrompt}>
									<I18n>not</I18n> {account.firstName || ""}?
									<div class={style.logOutLink} onClick={this.handleLogOut}>
										<I18n>clickHereTo</I18n>{" "}
										<span>
											<I18n>logout</I18n>
										</span>
									</div>
								</div>
							)}
						</div>
					)}
					{contentTitleContainer && (
						<div class={style.titleContainer}>
							{contentTitleContainer && contentTitleContainer.title && (
								<h1>{contentTitleContainer.title}</h1>
							)}
							{contentTitleContainer && contentTitleContainer.subTitle && (
								<h2>{contentTitleContainer.subTitle}</h2>
							)}
						</div>
					)}
					{this.hideStepsOnThisPage() && <Steps />}
				</div>

				<div class={style.containerPage}>
					<Page componentPage={"loginOrSignup"} component={LoginOrSignup} />
					<Page componentPage={"profileSelect"} component={ProfileSelect} />
					<Page componentPage={"login"} component={Login} />
					<Page componentPage={"passwordReset"} component={PasswordReset} />
					<Page
						componentPage={"resetPasswordPrompt"}
						component={ResetPasswordPrompt}
					/>
					<Page componentPage={"filters"} component={Filters} />
					<Page componentPage={"timeSlots"} component={TimeSlots} />
					<Page
						componentPage={"collectInformation"}
						component={CollectInformation}
					/>
					<Page componentPage={"confirmation"} component={Confirmation} />
					<Page componentPage={"receipt"} component={Receipt} />
					<Page componentPage={"payment"} component={Payment} />
				</div>
				<div class={style.containerFooter}>
					<a href="https://www.nextinline.io/">
						Powered by
						<div class={style.logoContainer}>
							<img src={nilLogo} alt="Next In Line" />
						</div>
					</a>
				</div>
			</div>
		);
	}
}

export default () => (
	<Provider store={store}>
		<Widget />
	</Provider>
);



// WEBPACK FOOTER //
// ./components/widget/index.js